import { useImmer } from "use-immer";
import { useCategoryQueries } from "../../modules/MasterData/hooks/useCategoryQueries";
import { useEffect } from "react";

export const useCategorySelect = ({categorylist})=>
{
    const [category, setCategory] = useImmer({
        id: 0,
        subData:[],
        subcategoryId:0
      });

      const detailsIds = category.id;

      const CategoryValuesHandler = (event, option) => {
        const selectedOption = option ? option.id : 0;
        setCategory((draft) => {
          draft.id = selectedOption;
        });
      };

      const SubCategoryValuesHandler = (event, option) => {
        const selectedOption = option ? option.id : 0;
        setCategory((draft) => {
          draft.subcategoryId = selectedOption;
        });
      };

      const {
        listQuery,
        categoryDetails,
      } = useCategoryQueries({
        categorylist,
        detailsIds
      });

      useEffect(() => {
        if (categoryDetails?.data) {
          setCategory((draft) => {
            draft.subData = categoryDetails.data.subData;
          });
        }
      }, [categoryDetails?.data]);

    return {listQuery,category,CategoryValuesHandler,SubCategoryValuesHandler}
}